import { useIntl } from 'react-intl';
import { HeaderProps } from '@rossum/components/header/Header';
import SearchInput from '@rossum/components/search-input/SearchInput';
import { IconRefresh } from '@rossum/ui/icons/tabler';
import { Button, SvgIcon, Tooltip } from '@rossum/ui/material';
import { ExtensionsHeader } from '../../../components/ExtensionsHeader';

type ActivitiesHeaderProps = Pick<HeaderProps, 'scrollableDivRef'> & {
  searchValue: string;
  setSearchValue: (value: string) => void;
  refreshRuns: () => void;
  isRefetching: boolean;
  dataUpdatedAt: number;
};

export const ActivitiesHeader = ({
  searchValue,
  setSearchValue,
  scrollableDivRef,
  refreshRuns,
  isRefetching,
  dataUpdatedAt,
}: ActivitiesHeaderProps) => {
  const intl = useIntl();

  return (
    <ExtensionsHeader
      scrollableDivRef={scrollableDivRef}
      value="activities"
      title={intl.formatMessage({
        id: 'features.activities.header.title',
      })}
      description={intl.formatMessage({
        id: 'features.activities.header.description',
      })}
      buttons={[
        <SearchInput
          key="search-activities"
          value={searchValue}
          onChange={setSearchValue}
        />,
        <Tooltip
          key="refresh-activities-button"
          title={
            dataUpdatedAt
              ? intl.formatMessage(
                  {
                    id: 'containers.settings.extensions.logs.dataUpdatedAt',
                  },
                  {
                    date: intl.formatDate(dataUpdatedAt, {
                      dateStyle: 'medium',
                      timeStyle: 'medium',
                    }),
                  }
                )
              : ''
          }
        >
          <Button
            data-cy="refresh-logs-button"
            variant="contained"
            onClick={!isRefetching ? refreshRuns : undefined}
            startIcon={
              <SvgIcon fontSize="large">
                <IconRefresh />
              </SvgIcon>
            }
          >
            {intl.formatMessage({
              id: 'features.activities.header.refresh',
            })}
          </Button>
        </Tooltip>,
      ]}
    />
  );
};
